import { detailsSmallCss } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
  display: flex;
  transition: display 0.1s ease-in-out;
  flex-direction: column;
`;

const Icon = styled.div<{ scrolled: number; isOpen: boolean; open: boolean }>`
  .gatsby-image {
    display: ${({ open }) => (open ? "none" : "block")};
    height: 32px;
    width: 32px;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    filter: ${({ scrolled, isOpen }) =>
      scrolled || isOpen
        ? "invert(50%) sepia(6%)"
        : ""};
    @media screen and (min-width: 821px) {
      &:hover {
        filter: ${({ theme }) => theme.filter.gold};
      }
    }
  }
`;

const Ul = styled.ul<{ open: boolean }>`
  background-color: transparent;
  background-color: #ffffff;
  padding: 20px;
  list-style: none;
  position: absolute;
  top: 15px;
  left: 0;
  transform: translate(-100%, -50%);
  width: fit-content;
  height: ${({ open }) => (open ? "auto" : "0")};
  visibility: ${({ open }) => (open ? "visible" : "hidden")};
  opacity: ${({ open }) => (open ? "1" : "0")};
  transition: height 0.3s ease-in-out, opacity 0.3s ease-in-out,
    visibility 0s ease-in-out;
`;

const Li = styled.li<{ active: boolean }>`
  a {
    white-space: nowrap;
    ${detailsSmallCss}
    text-decoration: none;
    color: ${({ active, theme }) =>
      active ? theme.textColors.tertiary : theme.textColors.primary};

    @media ${({ theme }) => theme.breakpoints.hover} {
      &:hover {
        color: ${({ theme }) => theme.textColors.tertiary};
      }
    }
  }
`;

const Hamburger = styled.div<{ active: boolean }>`
  display: ${({ active }) => (active ? "block" : "none")};
  z-index: 100;
  cursor: pointer;
  margin-top: 6px;
  transition: transform 0.3s ease-in-out;
  transform: ${({ active }) =>
    active ? "translateX(13px) " : "translateX(0)"};

  &:hover hr {
    border-color: ${({ theme }) => theme.colors.tertiary};
  }
`;

const HamburgerLine1 = styled.hr<{
  active: boolean;
  scrolled: number;
  isOpen: boolean;
}>`
  width: 36px;
  border-top: 1px;
  border-style: solid;
  margin-bottom: 9px;
  border-color: ${({ theme, scrolled, isOpen }) =>
    scrolled || isOpen ? theme.textColors.primary : theme.textColors.secondary};
  transform: ${({ active }) =>
    active ? "rotate(-45deg) translateX(-15px) " : "rotate(0) translateX(0)"};
  transition: transform 0.3s ease-in-out;
`;
const HamburgerLine2 = styled.hr<{
  active: boolean;
  scrolled: number;
  isOpen: boolean;
}>`
  width: 36px;
  border-top: 1px;
  border-style: solid;
  margin-bottom: 9px;
  border-color: ${({ theme, scrolled }) =>
    scrolled ? theme.textColors.primary : theme.textColors.secondary};
  transform: ${({ active }) => (active ? "translateX(60px)" : "translateX(0)")};
  opacity: ${({ active }) => (active ? "0" : "1")};
  transition: transform 0.3s ease-in-out;
`;
const HamburgerLine3 = styled.hr<{
  active: boolean;
  scrolled: number;
  isOpen: boolean;
}>`
  width: 36px;
  border-top: 1px;
  border-style: solid;
  margin-bottom: 9px;
  border-color: ${({ theme, scrolled, isOpen }) =>
    scrolled || isOpen ? theme.textColors.primary : theme.textColors.secondary};
  transform: ${({ active }) =>
    active ? "rotate(45deg) translateX(-15px)" : "rotate(0) translateX(0)"};
  transition: transform 0.3s ease-in-out;
`;

const S = {
  Container,
  Icon,
  Ul,
  Li,
  Hamburger,
  HamburgerLine1,
  HamburgerLine2,
  HamburgerLine3,
};

export default S;
